module.exports = __webpack_public_path__ + "static/media/black_joker.6d47a625.svg";